import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PreviousResults from './pages/PreviousResults';
import CommonNumbers from './pages/CommonNumbers';
import HouseTarget from './pages/HouseTarget';
import DreamNumber from './pages/DreamNumber';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App flex flex-col min-h-screen">
          <Routes>
            {/* Admin Routes (without Header/Footer) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            
            {/* Public Routes (with Header/Footer) */}
            <Route path="/*" element={
              <>
                <Header />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/previous-results" element={<PreviousResults />} />
                    <Route path="/common-numbers" element={<CommonNumbers />} />
                    <Route path="/house-target" element={<HouseTarget />} />
                    <Route path="/dream-number" element={<DreamNumber />} />
                    {/* Redirect old blog URLs to homepage (301 redirect) */}
                    <Route path="/blog" element={<Navigate to="/" replace />} />
                    <Route path="/blog/*" element={<Navigate to="/" replace />} />
                    {/* 404 catch-all route */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
